import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../helpers/helpers";
import _ from "lodash";
import { Table } from "./table";
import { toJS } from "mobx";
import { TableHeader } from "./survey-summary";
import { useTranslation } from "react-i18next";
import { useTableVisibility } from "./use-table-visibility";
import { QaStatusCard } from "./qa-status-card";

export const SurveysByQaCheckOly = observer((props) => {
    const { surveyResponseStore, userStore } = useStore();
    const { allSurveyResponsesSummary } = surveyResponseStore;
    const [t] = useTranslation(["analytical_summary", "survey_management"]);
    const isVisible = useTableVisibility("surveys_by_qa_check_only");

    const data = useMemo(
        () => toJS(allSurveyResponsesSummary)?.["by_qa_status"] || [],
        [allSurveyResponsesSummary]
    );

    const columns = useMemo(
        () => [
            {
                Header: t("status"),
                accessor: "status",
                Footer: t("total", { ns: "survey_management" }),
            },
            {
                Header: t("no_of_interviews", { ns: "survey_management" }),
                accessor: "value",
                Footer: surveyResponseStore.get_total_surveys(data, "value"),
            },
        ],
        [allSurveyResponsesSummary]
    );

    if (!isVisible) return null;
    if (!allSurveyResponsesSummary) return null;
    if (_.isEmpty(allSurveyResponsesSummary["by_qa_status"]) || userStore.is_field_worker()) return null;

    const row_click_handler = (x) => {
        surveyResponseStore.update_new_filters("qa_status", x["status"], `QA Status: ${x["status"]}`);
    };

    return (
        <div className="w-100 flex flex-col md:w-0">
            <TableHeader title={t("interviews_by_qa_status", { ns: "survey_management" })} />
            <Table data={data} columns={columns} onRowClick={row_click_handler} />

            {/*<QaStatusCard*/}
            {/*    data={data}*/}
            {/*    onItemClick={(status) =>*/}
            {/*        surveyResponseStore.update_new_filters("qa_status", status, `QA Status: ${status}`)*/}
            {/*    }*/}
            {/*/>*/}
        </div>
    );
});
